export default __webpack_public_path__ + "static/media/HelveticaNowDisplay-Bold.06043486.ttf";